module.exports = __webpack_public_path__ + "img/15@2x.8f248709.png";